import axios from 'axios';
import { normalize } from 'normalizr';
import { toCategoryModel } from '../../mappers/categories/toCategoryModel';
import { categorySchema } from './schema';
import type { CategoryDataModel } from './types';

export async function loadCategories(): Promise<{
    categories: Array<CategoryDataModel['id']>;
    records: {
        categories: CategoryDataModel[];
    };
}> {
    const response = await axios.get('/categories');
    const normalized = normalize(
        { categories: response.data.categories.map(toCategoryModel) },
        { categories: [categorySchema] },
    );

    return {
        categories: normalized.result.categories,
        records: {
            categories: Object.values<CategoryDataModel>(normalized.entities.categories ?? {}),
        },
    };
}
